export var isValidPhoneNumber = function(input) {
    var cleaned = input.replace(/[^\d+]/g, '');
    if (cleaned.startsWith('+')) {
        cleaned = "+".concat(cleaned.slice(1).replace(/\+/g, ''));
    } else {
        cleaned = cleaned.replace(/\+/g, '');
    }
    return cleaned;
};
